import React from 'react'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'
import { Link } from 'react-router-dom'

function Ongoing_project() {
  return (
    <div>
        <Header/>
        <div class="page-banner-area mt-5">
        <div class="container-fluid pt-4">
            <div class="page-banner-content">
                <h1> <b>ONGOING PROJECTS</b></h1>
                <ul class="list">
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li> PROJECTS</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="properties-area pt-100">
        <div class="container">
            <h2 CLASS="text-center pb-95"><b>मेरी बेटी मेरा गौरव अभियान</b></h2>
            <div class="row justify-content-center" data-cues="slideInUp">
               
                <div class="col-xl-6 col-md-6">
                      
                    <div class="properties-item">
                        <div class="properties-image">
                          
                        <img src="/img/newr.jpeg" alt="Shanti Farms" style={{width:'100%'}} />

                            <ul class="action">
                                <li>
                                
                                </li>
                               
                            </ul>
                            {/* <ul class="link-list">
                                <li>
                                    <a href="#" class="link-btn">Farm Houses</a>
                                </li>
                                <li>
                                    <a href="#" class="link-btn">For Sale</a>
                                </li>
                            </ul> */}
                        </div>
                       
                            <div class="properties-content">
                            <div class="top">
                                <div class="title">
                                    <h3>
                                        <a href="#">मेरी बेटी मेरा गौरव अभियान</a>
                                    </h3>
                                    <span> JODHPUR, NAGAUR</span>
                                </div>
                                {/* <div class="price">6,950 Rs <a href="shanti-farms.html" class=" btn btn-primary">Full Details</a></div> */}
                                  
                        
                            </div>
     
                           
                        </div>
                    </div>
                    
                </div>
               
                <div class="col-xl-6 col-md-6">
                    <div class="properties-item">
                        <div class="properties-image">
                           
                        <img src="/img/newp (1).jpeg" alt="Shanti Farms" style={{width:'100%'}} />
                                
                            <ul class="action">
                                <li>
                                    <a href="#" class="featured-btn">Current</a>
                                </li>
                               
                            </ul>
                            <ul class="link-list">
                                {/* <li>
                                    <a href="#" class="link-btn">Shops</a>
                                </li>
                                <li>
                                    <a href="#" class="link-btn">For Sale</a>
                                </li> */}
                            </ul>
                          
                        </div>
                        <div class="properties-content">
                            <div class="top">
                                <div class="title">
                                    <h3>    
                                        <a href="#">मेरी बेटी मेरा गौरव अभियान</a>
                                    </h3>
                                    <span> JODHPUR, NAGAUR</span>
                                </div>
                                {/* <div class="price">6,950 Rs <a href="shanti-farms.html" class=" btn btn-primary">Full Details</a></div> */}
                                  
                        
                            </div>
     
                           
                        </div>
                    </div>
                </div>
               
               </div>
        </div>
    </div>
<Footer/>
    </div>
  )
}

export default Ongoing_project